


















import { PriceRange, PriceViewState } from '@/components/molecules/item/price/model/item-price-view'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class RegularPrice extends Vue {
  @Prop({ required: true })
  readonly state: PriceViewState

  @Prop({ required: true })
  readonly onlyShowPriceWithTax: boolean

  get displayRange(): PriceRange {
    return this.state.nonPaidMemberPrice.range
  }
}
